<!-- Left side column. contains the logo and sidebar -->
<aside class="main-sidebar sidebar-dark-primary elevation-4" *ngIf="!loadingMenu">
  <app-logo></app-logo>
  <!-- sidebar: style can be found in sidebar.less -->
  <div class="sidebar">
    <!-- Sidebar user panel (optional) -->
    <!-- <div *ngIf="display_menu_user" class="user-panel mt-3 pb-3 mb-3 d-flex">
      <div class="image" *ngIf="currentUser?.avatarUrl">
        <img [src]="currentUser?.avatarUrl" class="img-circle elevation-2" [alt]="currentUser?.getName()" />
      </div>
      <div class="info">
        <a href="#">{{ currentUser?.getName() }}</a>
      </div>
    </div> -->
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview">
        <div *ngIf="router.url.startsWith('/documentos')" class="form-inline">
          <div class="input-group">
            <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search" [(ngModel)]="searchText" (keydown.enter)="getSearch(searchText)" >
            <div class="input-group-append">
              <button class="btn btn-sidebar" (click)="getSearch(searchText)">
                <i class="fas fa-search fa-fw"></i>
              </button>
            </div>
          </div>
          <li class="nav-item" (click)="toggleExactSearchEnabled()">
            <a class="nav-link">
              <input class="form-check-input" type="checkbox" name="exactSearchEnabled" [(ngModel)]="exactSearchEnabled" />
              {{ translate.instant("SHARED.enableExactSearch") }}
            </a>
          </li>
        </div>
    <!-- <form *ngIf="router.url.startsWith('/documentos')" action="#" method="get" class="form-inline">
      <div class="input-group">
        <input type="text" name="search" class="form-control" [(ngModel)]="searchText" autocomplete="off"
          placeholder="{{ translate.instant('PAGES.wordsOrId') }}" />
        <span class="input-group-btn">
          <button type="submit" name="search" id="search-btn" class="btn btn-flat" (click)="getSearch(searchText)">
            <i class="fa fa-search"></i>
          </button>
        </span>
      </div>
      <ul class="sidebar-menu">
        <li style="padding: 6px 3px 6px 15px">
          <span>
            <a (click)="toggleExactSearchEnabled()">
              <input type="checkbox" name="exactSearchEnabled" [(ngModel)]="exactSearchEnabled" />
              {{ translate.instant("SHARED.enableExactSearch") }}
            </a>
          </span>
        </li>
      </ul>
    </form> -->

    <!-- /.search form -->
    <!-- Sidebar Menu -->
    
        <ng-container *ngFor="let item of links">
          <!-- HEADER -->
          <ng-container *ngIf="item.header">
            <li class="nav-header">{{ item.header }}</li>
          </ng-container>
          <!-- COMPONENT -->
          <ng-container *ngIf="
              item.class &&
              ((currentUser.selectedRole &&
                currentUser.selectedActivity.uploadDocs) ||
                currentUser.masterAdmin ||
                currentUser.isAdmin ||
                !currentUser.selectedRole)
            ">
            <app-component-loader [class_component]="item.class" [data]="item.data"></app-component-loader>
          </ng-container>
          <!-- LINK -->
          <ng-container *ngIf="
              item.link &&
              (('/upload' == item.link &&
                currentUser.selectedRole &&
                currentUser.selectedActivity.uploadDocs) ||
                '/upload' != item.link ||
                currentUser.masterAdmin ||
                currentUser.isAdmin ||
                !currentUser.selectedRole)
            ">
            <li class="nav-item">
              <a class="nav-link" *ngIf="!item.external" [class.active]="item.class_active" [routerLink]="item.link">
                <i class="nav-icon fa fa-{{ item.icon }}"></i>
                <p>{{ item.title }}</p>
              </a>
              <a class="nav-link" *ngIf="item.external"  [class.active]="item.class_active" [href]="item.link" [target]="item.target">
                <i class="nav-icon fa fa-{{ item.icon }}"></i>
                <p>{{ item.title }}</p>
              </a>
            </li>
          </ng-container>
          <!-- LINK WITH SUBLINKS -->
          <ng-container *ngIf="item.subitems; else noSubitems">
            <li class="nav-item" (click)="elementService.openCloseTreeview($event)">
              <a class="nav-link">
                <i *ngIf="item.icon" class="nav-icon fa fa-{{ item.icon }}"></i>
                <p>{{ item.title }}
                  <i class="right fa fa-angle-left"></i>
                </p>
              
              </a>
              <ul class="nav nav-treeview">
                <ng-container *ngFor="let subitem of item.subitems">
                  <li class="nav-item">
                    <a class="nav-link" [class.active]="subitem.class_active" *ngIf="!subitem.external" [routerLink]="subitem.link">
                      <i *ngIf="subitem.icon" class="nav-icon fa fa-{{ subitem.icon }}"></i>
                      <span>{{ subitem.title }}</span>
                    </a>
                    <a class="nav-link" [class.active]="subitem.class_active" *ngIf="subitem.external" [href]="subitem.link" [target]="subitem.target">
                      <i *ngIf="subitem.icon" class="nav-icon fa fa-{{ subitem.icon }}"></i>
                      <span>{{ subitem.title }}</span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </li>
          </ng-container>
          <ng-container *ngIf="item.hierarchicalFilter"> </ng-container>
          <ng-container *ngIf="item.filter && currentUser.selectedEmpresa.useFieldExtract">
            <app-filter class="nav-item"></app-filter>
          </ng-container>
          <ng-container *ngIf="
              item.valid &&
              ((currentUser.selectedRole &&
                currentUser.selectedActivity.classifyReviewDocs) ||
                currentUser.masterAdmin ||
                currentUser.isAdmin ||
                !currentUser.selectedRole)
            ">
            
            <!-- <li class="nav-item">
              <a class="nav-link" href="javascript:" (click)="openModal(item.valdata)">
                <i class="nav-icon fa-file-alt"></i>
                <span>{{ translate.instant('SHARED.validate')}} </span>
                
                <span class="badge badge-warning right">{{
                  pendentes
                  }}</span>
              
              </a>
            </li> -->
          </ng-container>
          <ng-container  *ngIf="item.metadataFilter">
            <app-metadata-filter class="nav-item"></app-metadata-filter>
          </ng-container>
          <ng-container *ngIf="item.calendarFilter">
            <app-calendar-filter [calendarId]="item.calendarId" class="nav-item"></app-calendar-filter>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="router.url.startsWith('/documentos')">
          
          <li class="nav-item">
            <a class="nav-link filter-checkbox-item" *ngIf="showLegadoButton" (click)="setStatusSupportValor(!filtroStatusSupport)">
              <input class="form-check-input" type="checkbox" [(ngModel)]="filtroStatusSupport" />
              <span class="filter-label">Documentos no suporte</span>
              <span class="badge badge-warning">{{ statusSupport }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link filter-checkbox-item" (click)="setPendenteValor(!filtroPendente)">
              <input class="form-check-input" type="checkbox" [(ngModel)]="filtroPendente" />
              <span class="filter-label">{{ translate.instant("SHARED.filterPendents") }}</span>
              <span class="badge badge-warning">{{ pendentes }}</span>
            </a>
          </li>
        </ng-container>
      </ul>
    </nav>
    
    <!-- /.sidebar-menu -->
    <a *ngIf="showDevelopedBy" class="sidebar-footer" href="https://www.ktgroup.com.br/" target="_blank" rel="noopener noreferrer"
      title="KT Group">
      <span class="sidebar-footer__rotulo">{{ translate.instant('LOGIN.developedBy') }}</span>
      <img class="sidebar-footer__logo" src="assets/img/login/ktgroup-wordmark-light.svg" alt="KT Group" />
    </a>
  </div>
  <!-- /.sidebar -->
</aside>